// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2b5GZ","alertIcon":"ConfirmModal_alertIcon__1hGnz"};